module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray-300 h-screen w-screen flex justify-center items-center"
  }, [_c('form', {
    staticClass: "bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4"
  }, [_c('h3', {
    staticClass: "font-bold uppercase mb-6 text-gray-700"
  }, [_vm._v("Ingrese sus credenciales")]), _c('div', {
    staticClass: "mb-4"
  }, [_c('label', {
    staticClass: "block text-grey-darker text-sm font-bold mb-2"
  }, [_vm._v(" Usuario"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "shadow appearance-none border rounded w-full py-2 px-3 text-grey-darker",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "mb-4"
  }, [_c('label', {
    staticClass: "block text-grey-darker text-sm font-bold mb-2"
  }, [_vm._v(" Password"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "shadow appearance-none border rounded w-full py-2 px-3 text-grey-darker",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "bg-blue-400 text-white font-bold py-2 px-4 rounded cursor-pointer",
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Ingresar")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03fb2201","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/view_login.vue
// module id = 225
// module chunks = 1